import auth from '@/router/auth'
import CategoryItemIndex from '@/components/user-schools/Index'
import CategoryItemCreate from '@/components/user-schools/Create'
import CategoryItemUpdate from '@/components/user-schools/Update'
import CategoryItemShow from '@/components/user-schools/Show'

export default [
  {
    path: '/user-schools',
    name: 'user-schools-index',
    component: CategoryItemIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/user-schools/create',
    name: 'user-schools-create',
    component: CategoryItemCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/user-schools/update/:id',
    name: 'user-schools-update',
    component: CategoryItemUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/user-schools/show/:id',
    name: 'user-schools-show',
    component: CategoryItemShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/user-schools/router.js